import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import logo from "@/assets/lvm-logo.png";
import { COMPANY } from "@/data/site";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-navy-950/85 backdrop-blur-xl border-navy-700"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            data-testid="header-logo"
            className="relative flex items-center gap-3 shrink-0"
          >
            <img
              src={logo}
              alt="LVM Drywall LLC logo"
              className="self-start mt-4 sm:mt-6 h-16 sm:h-24 lg:h-28 w-auto rounded-md shadow-lg shadow-navy-950/40"
            />
          </a>

          <nav className="hidden md:flex items-center gap-10">
            {NAV.map((item) => (
              <a
                key={item.label}
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className="font-display text-sm font-bold uppercase tracking-widest text-zinc-200 hover:text-brand-light transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href={COMPANY.phoneHref}
            data-testid="header-call-button"
            className="hidden md:flex items-center gap-2 bg-brand hover:bg-brand-dark text-navy-950 font-display font-bold uppercase tracking-wide text-sm px-6 py-3 transition-colors"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-navy-950/95 backdrop-blur-xl border-t border-navy-700 px-4 py-6 flex flex-col gap-5"
        >
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="font-display text-base font-bold uppercase tracking-widest text-zinc-100"
            >
              {item.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="mobile-call-button"
            className="flex items-center justify-center gap-2 bg-brand text-navy-950 font-display font-bold uppercase tracking-wide px-6 py-4 mt-2"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
        </div>
      )}
    </header>
  );
};
